import { render, staticRenderFns } from "./CustomerAttachmentsDownload.vue?vue&type=template&id=34e8af15"
import script from "./CustomerAttachmentsDownload.vue?vue&type=script&lang=js"
export * from "./CustomerAttachmentsDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports